var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgInformation = (_ref, ref) => {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "7EFB5892-2913-4577-B16C-38A94A686AD6") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "REIS_Wiregrame-V2",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "REIS_Homepage",
    transform: "translate(-1118.000000, -90.000000)",
    fill: "#707372"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Search_Bar",
    transform: "translate(803.000000, 76.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Information/Outline/30",
    transform: "translate(315.000000, 14.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10,-3.55271368e-15 C15.5228475,-3.55271368e-15 20,4.4771525 20,10 C20,15.5228475 15.5228475,20 10,20 C4.4771525,20 -3.55271368e-15,15.5228475 -3.55271368e-15,10 C-3.55271368e-15,4.4771525 4.4771525,-3.55271368e-15 10,-3.55271368e-15 Z M10,1.6 C5.3608081,1.6 1.6,5.3608081 1.6,10 C1.6,14.6391919 5.3608081,18.4 10,18.4 C14.6391919,18.4 18.4,14.6391919 18.4,10 C18.4,5.3608081 14.6391919,1.6 10,1.6 Z M11.1111111,7.30230913 L11.1111111,14.8148148 L8.88888889,14.8148148 L8.88888889,7.30230913 L11.1111111,7.30230913 Z M11.1111111,4.44444444 L11.1111111,6.28366429 L8.88888889,6.28366429 L8.88888889,4.44444444 L11.1111111,4.44444444 Z",
    id: "Combined-Shape"
  })))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgInformation);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Information.6fd00910a48185dffe64a44db716b11f.svg";